import script from "./product.vue?vue&type=script&setup=true&lang=js"
export * from "./product.vue?vue&type=script&setup=true&lang=js"

import "./product.vue?vue&type=style&index=0&id=0732e023&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0732e023"]])

export default __exports__